import styled from 'styled-components'
import SvgVideo from '@capture/capture-components/src/icons/Video'
import { colors, fontSize } from '~/assets/styleConstants'
import { msToHMS } from '~/utilities/dateOperations'

const VideoIndicatorWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`

const DurationText = styled.span`
    color: #fff;
    margin-left: 8px;
    font-size: ${fontSize.small_14};
    user-select: none;
`

export const VideoIndicator: React.FunctionComponent<{
    duration?: number
}> = ({ duration }) => (
    <VideoIndicatorWrapper>
        <SvgVideo color={colors.white} />
        {duration !== undefined && (
            <DurationText>{msToHMS(duration)}</DurationText>
        )}
    </VideoIndicatorWrapper>
)
